export default function BrandSection() {
  const brands = [
    { name: "牛哈哈", desc: "国产龙头品牌，专注儿童牛奶片研发10年，年销量超500万盒", logo: "ri-medal-line" },
    { name: "小奶牛", desc: "益生菌牛奶片开创者，拥有自主研发的微胶囊包埋技术专利", logo: "ri-flask-line" },
    { name: "萌纯", desc: "高钙牛奶片品类销量冠军，微囊化钙技术提升吸收率达40%", logo: "ri-award-line" },
    { name: "AussieGold", desc: "澳洲原装进口品牌，源自维多利亚州黄金牧场，品质有保障", logo: "ri-earth-line" },
    { name: "NatureDairy", desc: "新西兰高端品牌，全程草饲奶牛，有机认证，纯净天然", logo: "ri-leaf-line" },
    { name: "纯甄", desc: "无糖牛奶片领导品牌，赤藓糖醇代糖技术，零GI值控糖首选", logo: "ri-heart-pulse-line" },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
            严选品牌 品质保障
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            牛奶片库严格筛选每一个入驻品牌，只推荐经过我们实测认证的优质产品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {brands.map((brand) => (
            <div
              key={brand.name}
              className="flex items-start gap-4 p-5 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="w-11 h-11 rounded-xl bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className={`${brand.logo} text-lg text-secondary-600`}></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-900 mb-1">{brand.name}</h4>
                <p className="text-xs text-foreground-600 leading-relaxed">{brand.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}